import { combineReducers } from 'redux'
import { createReduxHistoryContext } from 'redux-first-history'
import { intlReducer } from 'react-intl-redux'
import { createHashHistory } from 'history'

import amazonSellerAccounts from './amazon_seller_accounts'
import account from './account'
import analytics from './analytics'
import cardInfo from './card_info'
import categories from './categories'
import chatbot from './chatbot'
import checklist from './checklist'
import extension from './extension'
import globalData from './global'
import inventory from './inventory'
import productCosts from './product_costs'
import registrations from './registrations'
import salesAnalytics from './sales_analytics'
import seats from './seats'
import sellerAccountSync from './seller_account_sync'
import sessions from './sessions'
import settings from './settings'
import sidebar from './sidebar'
import subscriptions from './subscriptions'
import suppliers from './suppliers'
import team from './team'
import banners from './banners'

const staticReducers = {
  amazonSellerAccounts,
  account,
  analytics,
  banners,
  cardInfo,
  categories,
  chatbot,
  checklist,
  extension,
  globalData,
  intl: intlReducer,
  inventory,
  productCosts,
  registrations,
  salesAnalytics,
  seats,
  sellerAccountSync,
  sessions,
  settings,
  sidebar,
  subscriptions,
  suppliers,
  team
}

// Dictionary to keep track of the registered async reducers
const asyncReducers = {}

function createRootReducer(overrideReducers = {}) {
  const { routerReducer } = createReduxHistoryContext({
    history: createHashHistory()
    // other options if needed
  })

  return combineReducers({
    router: routerReducer,
    ...staticReducers,
    ...asyncReducers,
    ...overrideReducers
  })
}

// Create an inject reducer function
// This function adds the async reducer, and creates a new combined reducer
export const injectReducers = (store, reducers) => {
  reducers.forEach(({ key, reducer }) => {
    // don't redefine existing reducers
    if (asyncReducers[key]) {
      return
    }

    asyncReducers[key] = reducer
  })

  store.replaceReducer(createRootReducer())
}

export default createRootReducer
